import Component from '@glimmer/component'
import { and } from 'ember-truth-helpers'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'

export enum PILL_APPEARANCE {
  // minimal appearance is styled as: no border/no background and remove icon
  // only visible on hover/focus.
  minimal = 'minimal',
  outline = 'outline-solid',
}

interface Signature {
  Element: HTMLButtonElement
  Args: {
    theme?: ThemeKeys
    appearance?: PILL_APPEARANCE.minimal | PILL_APPEARANCE.outline
    selected?: boolean
  }
  Blocks: {
    default: []
  }
}

export class Pill extends Component<Signature> {
  get isMinimal() {
    return this.args.appearance === PILL_APPEARANCE.minimal
  }

  get isOutline() {
    return this.args.appearance === PILL_APPEARANCE.outline
  }

  get isBlue() {
    return this.args.theme === ThemeKeys.blue
  }

  get isGreen() {
    return this.args.theme === ThemeKeys.green
  }

  get isDarkBlue() {
    return this.args.theme === ThemeKeys.darkBlue
  }

  get isBlack() {
    return this.args.theme === ThemeKeys.default || this.args.theme === undefined
  }

  <template>
    <button
      type="button"
      class="rounded-full border px-2 whitespace-nowrap
        {{if this.isMinimal 'border-transparent'}}
        {{if (and this.isOutline this.isBlue) 'border-cornflower-blue-325'}}
        {{if (and this.isOutline this.isGreen) 'border-ms-green-350'}}
        {{if (and this.isOutline this.isDarkBlue) 'border-wl-blue-300'}}
        {{if (and this.isOutline this.isBlack) 'border-black'}}
        {{if this.isBlue (if @selected 'bg-cornflower-blue-325 text-white' 'text-cornflower-blue-325 bg-transparent')}}
        {{if this.isGreen (if @selected 'bg-ms-green-350 text-white' 'text-ms-green-350 bg-transparent')}}
        {{if this.isDarkBlue (if @selected 'bg-wl-blue-300 text-white' 'text-wl-blue-300 bg-transparent')}}
        {{if this.isBlack (if @selected 'bg-black text-white' 'bg-transparent text-black')}}
        {{if @selected 'text-white'}}"
      ...attributes
    >
      {{yield}}
    </button>
  </template>
}

export default Pill
